<!-- todo: move -->
<template>
	<div id="conference-characteristics-panel" class="panel about_event">
		<div class="container">
			<ul class="programm_properties">
				<li v-if="'days' in block.content && block.content.days.ru !==null" class>
					<!-- <div class="digit">
						{{ block.content.days.ru }}
					</div> -->
					<div class="title">
						<!-- <span v-if="'intensity' in block.content && block.content.intensity.ru !== null">
							{{ block.content.intensity.ru }}
							<br>
						</span> -->
						<!-- <span
							v-if="'days_title' in block.content && block.content.days_title.ru !== null"
						>{{ block.content.days_title.ru }}</span> -->
						<span>{{ fetchedData.event_date | moment("HH:mm") }} — {{ fetchedData.event_date_end | moment("HH:mm") }}</span>
					</div>
				</li>
				<li v-if="'sessions' in block.content && block.content.sessions.ru !==null" class>
					<div class="digit">
						{{ block.content.sessions.ru }}
					</div>
					<div class="title">
						{{ $tc('sessions', block.content.sessions.ru) }}
					</div>
				</li>
				<li class>
					<div class="programm_properties_list">
						<div
							v-if="'languages' in block.content && block.content.languages.ru !==null"
							class="title"
						>
							<i class="icon-language" />
							{{ block.content.languages.ru }}
						</div>
						<div
							v-if="'place' in block.content && block.content.place.ru !==null"
							class="title"
						>
							<i class="icon-place" />
							{{ block.content.place.ru }}
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';

export default {
	name: 'ConferenceCharacteristics',
	props: ['block', 'fetchedData'],
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-about_event";
</style>

<i18n lang="yaml">
ru:
  sessions: "сессий | сессия | сессии | сессий"
en:
  sessions: "sessions | session | sessions"
</i18n>
